"use client"

import { SquareBottomDashedScissors } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareBottomDashedScissorsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareBottomDashedScissorsIcon = component(Icon)({
  as: SquareBottomDashedScissors,
})
